export default "__VITE_ASSET__53d2a655__"